export default {
  addQuizTypeAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addQuizType", payload)
      resolve()
    })
  }
}
